import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { defineMessages, useIntl } from 'dibs-react-intl';

import { NftFaq } from 'dibs-nft-faq/exports/NftFaq.tsx';
import { NftExhibitionsGrid } from './components/NftExhibitionsGrid.tsx';

import { useDeviceType } from '../nftHeader/hooks/useDeviceType.tsx';

import { type NftExhibitionsLayout_viewer$key } from './__generated__/NftExhibitionsLayout_viewer.graphql.ts';

import styles from './styles/NftExhibitionsLayout.scss';

const messages = defineMessages({
    exhibitionsHeading: {
        id: 'NftLanding.NftLandingLayout.exhibitionsHeading',
        defaultMessage: 'All Exhibitions',
    },
});

export type NftExhibitionsLayoutViewerKey = NftExhibitionsLayout_viewer$key;
export const NftExhibitionsLayout: FC<{
    viewer: NftExhibitionsLayout_viewer$key | null | undefined;
}> = ({ viewer: viewerProp }) => {
    const { deviceType } = useDeviceType();
    const { formatMessage } = useIntl();
    const viewer = useFragment(
        graphql`
            fragment NftExhibitionsLayout_viewer on Viewer {
                ...NftExhibitionsGrid_viewer
            }
        `,
        viewerProp
    );

    return (
        <>
            <div className={styles.pageHeading}>
                <h1 className={styles.pageTitle}>{formatMessage(messages.exhibitionsHeading)}</h1>
            </div>
            <NftExhibitionsGrid viewer={viewer} />
            <NftFaq deviceType={deviceType} />
        </>
    );
};
